import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { ShoppingCartPaymentState } from '@platform-frontend/checkout';
import { MARKETPLACE_MATOMO_EVENT_CATEGORY_PAYMENT, PaymentMethod, ScaService } from '@platform-frontend/marketplace';
import { CreditCardType } from '@platform-frontend/payment-util';
import { Navigate } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { ScaUrlService } from '../shared/sca-url.service';

@UntilDestroy()
@Component({
  selector: 'yat-sca-authentication',
  templateUrl: './sca-authentication.component.html',
  styleUrls: ['./sca-authentication.component.scss']
})
export class ScaAuthenticationComponent implements OnInit {
  constructor(private route: ActivatedRoute, private scaService: ScaService, private scaUrlService: ScaUrlService, private store: Store) {}

  @Select(ShoppingCartPaymentState.selectedPaymentMethod)
  selectedPaymentMethod$: Observable<PaymentMethod | null>;

  readonly MATOMO_EVENT_CATEGORY_PAYMENT = MARKETPLACE_MATOMO_EVENT_CATEGORY_PAYMENT;

  cardType: CreditCardType | null;

  ngOnInit(): void {
    this.cardType = this.scaService.getCardType();
  }

  continue(): void {
    const navExtras = { relativeTo: this.route };
    this.store.dispatch(new Navigate(['../sca-spinner'], navExtras));
  }

  cancel(): void {
    const navExtras = { relativeTo: this.route };
    const reason = this.scaService.getReason();
    this.scaService.cancel();
    this.store.dispatch(new Navigate([this.scaUrlService.getFailureUrl(reason)], navExtras));
  }

  @HostListener('window:popstate')
  onBackNavigation(): void {
    this.scaService.cancel();
  }
}
